/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import Styled from 'styled-components'

const Select = ({ activeSelect = 0, option = [], optionClick = () => {} }) => {
    const [onSelect, setOnSelect] = useState(0)
    const [openSelect, setOpenSelect] = useState(false)

    useEffect(() => {
        setOnSelect(activeSelect)
    }, [activeSelect])

    const onCilickOpenSelect = () => {
        setOpenSelect(!openSelect)
    }
    const onCilickOption = ({index, value}) => () => {
        if (index === onSelect) return

        setOnSelect(index)
        setOpenSelect(false)
        optionClick(value)
    }

    return (
        <SelectBox className={openSelect ? 'open' : ''}>
            <button type="button" className="btn_select" onClick={onCilickOpenSelect}>
                {option[onSelect].text}
            </button>
            {openSelect && (
                <ul className="layer_list">
                    {option.map((v, index) => (
                        <li key={index} className={onSelect === index ? 'active' : ''}>
                            <button
                                type="button"
                                className="select"
                                onClick={onCilickOption({index, value: v.value})}>
                                {v.text}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </SelectBox>
    )
}

const SelectBox = Styled.div`
    position: relative;
    display: inline-block;
    margin-left: 7px;
    vertical-align: top;

    &.open {
        .btn_select {
            &:after {
                border-bottom: 4px solid #a0a0a0;
                border-top: 3px solid transparent;
                margin-top: -3px;
            }
        }
    }

    .btn_select {
        position: relative;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 93px;
        height: 28px;
        padding: 0 17px 0 5px;
        border: 1px solid #bfbfbf;
        background: transparent;
        font-size: 11px;
        line-height: 28px;
        color: #999;
        text-align: left;
        vertical-align: top;
        box-sizing: border-box;

        &:after {
            position: absolute;
            top: 12px;
            right: 5px;
            display: inline-block;
            margin-left: 4px;
            border: 3px solid transparent;
            border-top: 4px solid transparent;
            border-top-color: #a0a0a0;
            vertical-align: -1px;
            content: "";
        }
    }
    .layer_list {
        position: absolute;
        top: 28px;
        right: 0;
        left: 0;
        z-index: 100;
        padding: 4px 0 0 5px;
        border: 1px solid #b5b5b5;
        background-color: #fff;

        li.active {
            .select {
                color: #418ded
            }
        }

        .select {
            border: 0;
            background: transparent;
            font-size: 11px;
            line-height: 20px;
            color: #777;
            text-align: left;
        }
    }
`

export default Select



// WEBPACK FOOTER //
// ./src/estimate_list/components/layout/select.js